import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-cms-content',
  templateUrl: 'cms-content.html',
  styleUrls: ['cms-content.scss'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class CmsContentComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() content;
  @Input() inlineBlock = true;
  @Input() css;

  @Output() afterInit = new EventEmitter<void>();

  styles = '';

  constructor() {
    this.updateStyles();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateStyles();
  }

  ngAfterViewInit(): void {
    this.afterInit.emit();
  }

  updateStyles() {
    if (!!this.css) {
      this.styles = `
      <style type="text/css">
      ${this.css}
      </style>
    `;
    } else {
      this.styles = null;
    }
  }

  async ngOnInit() {
    // console.log('init()');
  }
}
